class CustomReviews extends HTMLElement {
    constructor() {
        super();

        this.delay = this.querySelector('[data-delay]').getAttribute('data-delay');
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            autoplay: {
                delay: this.delay,
            },
            slidesPerView: 1,
            spaceBetween: 34,

            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            breakpoints: {
                450: {
                    slidesPerView: 1.2,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2.3,
                },
            },

        });

    }
}

customElements.define('custom-review', CustomReviews);